<div class="space-y-8">
  <div class="flex justify-between items-center">
    <h1 class="text-3xl font-bold text-slate-900">Financial Overview</h1>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
    
    <!-- Left Column -->
    <div class="lg:col-span-2 space-y-8">
      <app-credit-card 
        cardHolder="Jane Doe"
        cardNumber="4242 4242 4242 4242"
        expiryDate="12/26"
        cardType="visa"
        balance="5750.20"
        creditLimit="15000">
      </app-credit-card>

      <app-transactions-list></app-transactions-list>
    </div>

    <!-- Right Column -->
    <div class="lg:col-span-1 space-y-8">
        <app-account-balance></app-account-balance>
        <app-spending-breakdown></app-spending-breakdown>
        <app-quick-transfer></app-quick-transfer>
    </div>

  </div>
</div>
